import { FEE_LABEL, feeOn, builderTotal, money } from "@/lib/fees";

// Builder-facing: shows rate → + admin fee → total the builder pays. `amount` is what the tradie(s) receive.
export const FeeBreakdown = ({ amount, label = "To tradie", hint, testid = "fee-breakdown", compact = false }) => {
  const a = Number(amount) || 0;
  if (compact) {
    return (
      <span className="font-mono-data text-xs text-zinc-500" data-testid={testid}>
        {money(a)} + {FEE_LABEL} fee = <span className="text-white font-semibold" data-testid={`${testid}-total`}>{money(builderTotal(a))}</span> incl. GST
      </span>
    );
  }
  return (
    <div className="font-mono-data text-xs" data-testid={testid}>
      <div className="flex justify-between gap-6 text-zinc-400"><span>{label}{hint && <span className="text-zinc-600 ml-2">{hint}</span>}</span><span className="text-zinc-200">{money(a)}</span></div>
      <div className="flex justify-between gap-6 text-zinc-400 mt-0.5"><span>TradieLoop admin fee ({FEE_LABEL}, incl. GST)</span><span className="text-zinc-200">+ {money(feeOn(a))}</span></div>
      <div className="flex justify-between gap-6 mt-1 pt-1 border-t border-white/10 text-white"><span className="uppercase tracking-widest font-bold text-[10px] self-center">You pay <span className="text-zinc-400 font-semibold">(incl. GST)</span></span><span className="text-base font-semibold" data-testid={`${testid}-total`}>{money(builderTotal(a))}</span></div>
    </div>
  );
};
